import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Droppedstatuschange(state = initialState, action) {
  switch (action.type) {
    case userConstants.DROPPEDSTATUSCHANGE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.DROPPEDSTATUSCHANGE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.DROPPEDSTATUSCHANGE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}